import { useDispatch } from 'react-redux';
import { UUIReduxDispatch } from '../reducers/types';

export const useReduxDispatch = (): UUIReduxDispatch => useDispatch<UUIReduxDispatch>();
